/*@flow*/

export default function containsUnion(type: any): boolean {
  switch (type.meta.kind) {
    case 'union':
      return true;
    case 'maybe':
    case 'subtype':
      return containsUnion(type.meta.type);
    default:
      return false;
  }
}
